import './App.css';
import {React,useState} from "react"
import axios from "axios"


function App() {
  const [selectedFile, setSelectedFile] = useState();
  const [wind,setWind] = useState();
  const [result,setresult] = useState()

  const fileChangeHandler = (event) => {
		setSelectedFile(event.target.files[0]);
	};
  const textChangehandler = (event) => {
    setWind(event.target.value)
  }
  const handleSubmission = (event) => {
		const form = new FormData();
    form.append("file", selectedFile);
    form.append("wind",wind)

    const options = {
      method: 'POST',
      url: 'https://nothingtosee.herokuapp.com/tanks',
      headers: {'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'},
      data: form
    };
    setresult("Loading...")

    axios.request(options).then(function (response) {
      console.log(response.data);
      setresult(response.data)
    }).catch(function (error) {
      console.error(error);
    });
      event.preventDefault();
	};
  return (
    <div className="App">
      <header>
        <h1 className="">Gamepigeon Tanks Solver</h1>
      </header>
      <main>
        <form className=".uk-form-controls-text">
           <label class="uk-form-label">Upload Screenshot of Tanks Game:</label>
           <br />
           <input type="file" name="filename " id="file" className=".uk-input" onChange={fileChangeHandler}/>
           <br />
           <label class="uk-form-label">Enter Wind Value from -10 to 10 (number of arrows) example:-3.6,1.2 :</label>
           <br />
           <input type="number" name="wind" className=".uk-input"  onChange={textChangehandler}/>
           <br />

           <input type="submit" className=".uk-input"  onClick={handleSubmission}/>
        </ form >
        <h3>{result}</h3>
        </main>
        <footer>
          <p>Made By Olaf and Rishith</p>
        </footer>
    </div>
  );
}

export default App;
